export const getTagColor = {
  methods: {
    getTagColor(level) {
      var tagcolor = "";
      switch (level) {
        case "Advanced":
          tagcolor = "red";
          break;
        case "Junior":
          tagcolor = "orange";
          break;
        case "Begginer":
          tagcolor = "green";
          break;
        default:
          tagcolor = "grey";
      }
      return tagcolor;
    }
  }
};
